/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export enum SourceOrderProduct{
  CART,
  SPECIFICATION,
  ORDER,
  ORDER_PART
}

export interface OrderForm {
  deliveryMethod: number;
  pickupAddress: number;
  deliveryAddress: number;
  comment?: string;
  cart?: number[];
  source: SourceOrderProduct;
  sourceId: number | null;
}
